export default __webpack_public_path__ + "static/media/amaia.4ee129d4.jpg";